import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import SwornTranslatorProductPage from "@/components/SwornTranslatorProductPage";
import { swornProductGraph, defaultSwornProductFaqs } from "@/lib/sworn-translator-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/sworn-translator/products/$slug")({
  loader: async ({ params }) => {
    const { getSwornProduct } = await import("@/data/sworn-translator-products");
    const p = getSwornProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("ไม่พบบริการ", "/sworn-translator/products/$slug", "th")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/sworn-translator/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `แปลสาบาน ${p.nameTh} — นักแปลรับรอง | ${p.turnaround}`;
    const desc = p.shortDescTh + " · นักแปล MoJ + เครือข่าย sworn translator ปลายทาง (DE/FR/ES/IT/NL/PL) · Bundle Notary + MFA + Apostille ในสำนักงานเดียว";
    const faqs = defaultSwornProductFaqs(p, "th");
    return {
      meta: [
        { title: ctaTitle(title, "/sworn-translator/products/$slug", "th") }, { name: "description", content: ctaDesc(desc, "/sworn-translator/products/$slug", "th")},
        { property: "og:title", content: ctaTitle(title, "/sworn-translator/products/$slug", "th")},
        { property: "og:description", content: ctaDesc(desc, "/sworn-translator/products/$slug", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "th_TH" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: url },
        { rel: "alternate", hrefLang: "en", href: `${BRAND_URL}/en/sworn-translator/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: url },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(swornProductGraph({ product: p, locale: "th", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">ไม่พบบริการที่ค้นหา</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <SwornTranslatorProductPage product={product} locale="th" faqs={defaultSwornProductFaqs(product, "th")} />;
  },
});
